const ACCESS_TOKEN_KEY = "authToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const REMEMBER_ME_KEY = "rememberMe";

const getRememberMe = () => localStorage.getItem(REMEMBER_ME_KEY) === "true";

const getPrimaryStorage = () => (getRememberMe() ? localStorage : sessionStorage);

const getFallbackStorage = () => (getRememberMe() ? sessionStorage : localStorage);

const persistTokens = ({ accessToken, refreshToken, remember }) => {
  localStorage.setItem(REMEMBER_ME_KEY, remember ? "true" : "false");
  const target = remember ? localStorage : sessionStorage;
  const other = remember ? sessionStorage : localStorage;

  target.setItem(ACCESS_TOKEN_KEY, accessToken);
  target.setItem(REFRESH_TOKEN_KEY, refreshToken);
  other.removeItem(ACCESS_TOKEN_KEY);
  other.removeItem(REFRESH_TOKEN_KEY);
};

const getAccessToken = () =>
  getPrimaryStorage().getItem(ACCESS_TOKEN_KEY) || getFallbackStorage().getItem(ACCESS_TOKEN_KEY);

const getRefreshToken = () =>
  getPrimaryStorage().getItem(REFRESH_TOKEN_KEY) || getFallbackStorage().getItem(REFRESH_TOKEN_KEY);

const updateAccessToken = (accessToken) => {
  if (!accessToken) {
    return;
  }
  getPrimaryStorage().setItem(ACCESS_TOKEN_KEY, accessToken);
};

const updateRefreshToken = (refreshToken) => {
  if (!refreshToken) {
    return;
  }
  getPrimaryStorage().setItem(REFRESH_TOKEN_KEY, refreshToken);
};

const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(REMEMBER_ME_KEY);
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
};

export {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  REMEMBER_ME_KEY,
  persistTokens,
  getRememberMe,
  getAccessToken,
  getRefreshToken,
  updateAccessToken,
  updateRefreshToken,
  clearTokens,
};
